//DIESYS MODAL
document.addEventListener('DOMContentLoaded', function() {
    var bottone = document.getElementById('diesys-button') || document.getElementById('diesys-button-home');
    var modal = document.getElementById('diesys-modal');
    var chiudi = document.getElementsByClassName('chiudi-modal')[0];
    
    // Quando l'utente clicca sul bottone, apri il modal
    bottone.onclick = function() {
      modal.style.display = "block";
    }
    
    // Quando l'utente clicca sulla X, chiudi il modal
    chiudi.onclick = function() {
      modal.style.display = "none";
    }
    
    // Quando l'utente clicca al di fuori del modal, chiudilo
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
    // Ottieni i parametri dalla URL
    const urlParams = new URLSearchParams(window.location.search);
  
    // Controlla se 'drp' è uguale a 'dsrp'
    if (urlParams.get('drp') === 'dsrp') {
      // Cerca uno dei due bottoni
      const bottone = document.getElementById('diesys-button') || document.getElementById('diesys-button-home');
  
      // Se il bottone esiste, cliccalo
      if (bottone) {
        bottone.click();
      }
    }
  });

// Terms & Conditions checkbox at the cart


document.querySelector('body').addEventListener('click', event => {
    // This version checks the current element for a match, as well as it's parents.
    // If none is found, it returns null
  //console.log('click');
  //console.log(event.target);
    if (event.target.matches('#checkout_sticky') || event.target.matches('#checkout') || event.target.closest('#checkout_sticky') || event.target.closest('#checkout') ) {

      var agree = document.querySelector("#agree");
      
        console.log('click on button');
      
    	if(!agree.checked){
          var agree_error = document.querySelector("#checkout-is-required-input");
          console.log('agree not checked');
          event.preventDefault();
          agree_error.removeAttribute("hidden");
          
          agree_error.focus();
        }
    }
});

/*
var checkout = document.querySelector("#checkout");
var checkout2 = document.querySelector("#checkout_sticky");
if(checkout ){
document.addEventListener("DOMContentLoaded", () => {
  
 
  checkout.addEventListener("click", function(e){
   alert(1);
    
  });
  checkout2.addEventListener("click", function(e){
    alert(2);
    if(!agree.checked){
      agree_error.removeAttribute("hidden");
      //alert("You must agree with the terms and conditions of sales to check out.");
      e.preventDefault();
      
      agree.focus();
    }
  });
});
}
*/


var readmore = document.querySelector(".readmore");
  if(readmore){
readmore.addEventListener("click", function(e){
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});

var readless = document.querySelector(".readless");
readless.addEventListener("click", function(e){
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block';
});  
  }




const productscard = document.querySelectorAll(".product-card");
productscard.forEach(function(productcard) {
  productcard.addEventListener("mouseenter", function() {
    
    if (productcard.getElementsByClassName("product-card__image-swatches")[0].innerHTML === "") {
      let value = productcard.dataset.id;
      fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=" + value + "&limit=4&intent=complementary")
      .then(response => response.json())
      .then(({ products }) => {
        if (products.length > 0) {

          productcard.classList.remove("product-card--with-color-swatches-hide-on-desktop");
          productcard.classList.add("product-card--with-color-swatches-on-hover");
          
          products.forEach(function(item, index){ 
            productcard.getElementsByClassName("product-card__image-swatches")[0].innerHTML +=
                  `<a href="${item.url}" class="image-swatches__item unstyled-link image-swatches__item--portrait">
                  <div class="image-swatches__item-body-wrapper image-swatches__item-body-wrapper--portrait ">
                      <img class="image-swatches__item-body lazyautosizes ls-is-cached lazyloaded" src="${item.images[0]}&width=40" data-aspectratio="0.75" data-sizes="auto" alt="${item.title}" loading="eager" width="1" height="1" sizes="40px">                       
                  </div>
              </a>`;
            
          });
          
          
        }
      }         
      );

  };
      
  });
});

/*
var elementsStart = document.querySelectorAll(`.faq__accordeon-plus[data-aria-expanded="false"] .faq__accordeon-plus-btn`);
if(elementsStart){
  setTimeout(() => {
    elementsStart.forEach(function(elementStart) {
    console.log(elementStart);
      elementStart.click();
    }); 
  }, "1000");
   
}
*/


const brandlinks = document.querySelectorAll(".brand-link");
if(brandlinks){
  brandlinks.forEach(function(brandlink) {

    

    brandlink.addEventListener("click", function(element) {
      
        let where = brandlink.dataset.where;
      console.log(brandlink.dataset.where);
        var element = document.querySelector(`.${where}[data-aria-expanded="false"] .faq__accordeon-plus-btn`);
        if(element){
          element.click();
        }
        var elementToScroll = document.querySelector(`.${where}`);
        const y = elementToScroll.getBoundingClientRect().top + window.scrollY - 150;
        window.scroll({
          top: y,
          behavior: 'smooth'
        });
    });
  });
}

window.onscroll = () => {
  const header = document.getElementById('shopify-section-sections--22005345288510__header');
  if (header) {
    header.setAttribute('aria-hidden', 'false');
  }
}



